'use client';

/*
Presse & média — mise en page alignée sur la homepage v5.
*/
import Head from '@/core/head';
import { lang, hocT } from '@/helpers/translate';
import { getCanonicalUrl } from '@/helpers/router.js';
import { FadeUp } from '@/core/motion';
import {
  SECTION, BTN_PRIMARY, BTN_SECONDARY, Kicker, ArrowIcon, kicker,
} from '@/core/editorial';

export default hocT(({ t }) => {
  const langCurrent = lang();
  const canurls = getCanonicalUrl('press', langCurrent);

  return (
    <div className="bg-white font-display text-was-ink">
      <Head>
        {canurls.map((cprops) => <link key={JSON.stringify(cprops)} {...cprops} />)}
      </Head>
      <section className="flex min-h-[calc(100vh-76px)] items-center bg-white pt-[76px]">
        <div className={`${SECTION} w-full`}>
          <FadeUp>
            <Kicker n="01">{kicker(langCurrent, 'press', 0)}</Kicker>
            <h1 className="mt-5 max-w-[820px] text-balance font-heading text-[32px] font-extrabold uppercase leading-[1.04] tracking-[-0.01em] md:text-[40px] lg:text-[46px]">{t('press:title')}</h1>
            <p className="mt-6 max-w-[620px] text-lg leading-relaxed text-was-slate">{t('press:desc')}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a className={BTN_PRIMARY} href="mailto:press@wearescene.com">
                press@wearescene.com
                <ArrowIcon />
              </a>
              <a className={BTN_SECONDARY} href="tel:+33159134277">+33 1 59 13 42 77</a>
            </div>
          </FadeUp>
        </div>
      </section>
    </div>
  );
});
